/**
 * This service file used to connect the profile changes while update profile image its update on top icon also.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private profileImageUpdate = new Subject<void>();
  private variableReferenceId = new BehaviorSubject<any>({})
  variableReferencesViewEvents$: Observable<any> = this.variableReferenceId.asObservable();

  updateProfile() {
    this.profileImageUpdate.next();
  }

  getUpdateObservable() {
    return this.profileImageUpdate.asObservable();
  }

  viewVariableReference(response){
    this.variableReferenceId.next({
      data: response
    })
  }
  
}
